import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

// Registers the native app for push notifications (no-op on the web).
//
// Rendered on the native More menu's Notifications row. On connect it sends
// `register` to the shell's PushComponent, which asks the OS for notification
// permission, obtains the APNs/FCM token, and replies with
// { token, platform, deviceIdentifier, permission }:
//
//   token            — APNs/FCM device token (absent when permission denied
//                      or OS/FCM registration failed)
//   platform         — "apple" | "google" (PushDevice's enum values)
//   deviceIdentifier — stable per-install id (identifierForVendor/ANDROID_ID)
//   permission       — "granted" | "denied" | "error"; only "granted" shows
//                      the row as "On"
//
// We then POST the token to /hotwire_native/device_tokens (session-cookie
// auth; CSRF token sent from the meta tag), surface the permission state on
// the menu row, and append the device identifier to the logout link so
// user_sessions#destroy can delete the PushDevice on logout.
export default class extends BridgeComponent {
  static component = "push";
  static targets = ["status"];

  connect() {
    super.connect();
    this.send("register", {}, (message) =>
      this.handleRegistration(message.data)
    );
  }

  handleRegistration({ token, platform, deviceIdentifier, permission }) {
    this.showPermission(permission);
    if (deviceIdentifier) this.tagLogoutLinks(deviceIdentifier);
    if (token) this.registerDevice(token, platform, deviceIdentifier);
  }

  registerDevice(token, platform, deviceIdentifier) {
    fetch("/hotwire_native/device_tokens", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")
          ?.content,
      },
      body: JSON.stringify({
        token,
        platform,
        device_identifier: deviceIdentifier,
      }),
    });
  }

  // The shell owns the device identifier, so the logout link only learns it
  // here — user_sessions#destroy uses it to remove this install's PushDevice.
  tagLogoutLinks(deviceIdentifier) {
    document.querySelectorAll("a.logout").forEach((link) => {
      const url = new URL(link.getAttribute("href"), window.location.origin);
      url.searchParams.set("device_identifier", deviceIdentifier);
      link.setAttribute("href", url.pathname + url.search);
    });
  }

  showPermission(permission) {
    if (!this.hasStatusTarget || !permission) return;

    this.statusTarget.textContent = permission === "granted" ? "On" : "Off";
    this.statusTarget.hidden = false;
  }
}
